import React, { useState, useEffect } from 'react';
import './Library.css';

// Import images for Library
import library1 from '../assets/library (1).webp';
import library2 from '../assets/library (2).webp';
import library3 from '../assets/library (3).webp';
import library4 from '../assets/library (4).webp';

const Library = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const libraryImages = [library1, library2, library3, library4];

  useEffect(() => {
    setIsVisible(true);
    
    // Auto-slide images every 3 seconds
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === libraryImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const handleDotClick = (index) => {
    setCurrentImageIndex(index);
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? libraryImages.length - 1 : prevIndex - 1
    );
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === libraryImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="library-container">
      {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>LIBRARY</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Library</li>
          </ul>
        </div>
      </section>
      {/* Main Content */}
      <div className="library-main-content">
        <div className="library-content-wrapper">
          {/* Left Side - Text Content */}
          <div className={`library-text-content ${isVisible ? 'library-visible' : ''}`}>
            <h2 className="library-main-heading">LIBRARY</h2>
            
            <p className="library-section-text">
              The serene ambience inspires a love for reading. Information at the click of a finger tip 
              invites the young users to delve into the magical world of words and the wealth of research 
              material available. Interaction with eminent authors, book reviews and reading sessions are 
              conducted regularly exposing students to good written and reading skills.
            </p>

            <p className="library-section-text">
              The reference library, which is fully computerized and houses over 30,000 books, is a treasure 
              trove of information that has been built assiduously over a span of more than 5 decades and 
              continues to grow each year.
            </p>

            <p className="library-section-text">
              Our library is equipped with a vast collection of books spanning various genres including fiction, 
              non-fiction, reference materials, encyclopedias, and periodicals. Students have access to digital 
              resources and online databases that supplement their learning and research activities.
            </p>

            <p className="library-section-text">
              The library provides a quiet and conducive environment for reading, studying, and research. With 
              comfortable seating arrangements and modern facilities, students can immerse themselves in the 
              world of knowledge and develop critical thinking skills.
            </p>

            <p className="library-section-text">
              Regular library orientation programs, book fairs, author interactions, and reading competitions 
              are organized to foster a reading culture among students. The library staff is always available 
              to assist students in finding resources and guiding them in their academic pursuits.
            </p>
          </div>

          {/* Right Side - Image Slider */}
          <div className={`library-image-slider ${isVisible ? 'library-visible' : ''}`}>
            <div className="library-slider-container">
              {libraryImages.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Library ${index + 1}`}
                  className={`library-slider-image ${
                    index === currentImageIndex ? 'library-active' : ''
                  }`}
                />
              ))}
              
              {/* Navigation Arrows */}
              <button 
                className="library-slider-arrow library-arrow-left"
                onClick={handlePrevImage}
              >
                ‹
              </button>
              <button 
                className="library-slider-arrow library-arrow-right"
                onClick={handleNextImage}
              >
                ›
              </button>
              
              {/* Slider Dots */}
              <div className="library-slider-dots">
                {libraryImages.map((_, index) => (
                  <span
                    key={index}
                    className={`library-dot ${
                      index === currentImageIndex ? 'library-dot-active' : ''
                    }`}
                    onClick={() => handleDotClick(index)}
                  ></span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Library;